<template>
    <section>
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
        <div v-show="!loading" class="content">
            <div class="box">
                <div class="box-body">
                    <div class="row">
                        <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                        </div>
                    </div>
                    <div id="details" class="row">
                        <div class="col-sm-12 text-right"
                            v-permission.if="[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD]">
                            <button class="btn btn-danger mr-5" type="button" @click="deleteVehicleModal">Delete
                                Vehicle</button>
                        </div>
                        <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                            <div class="col-sm-12">
                                <div class="col-sm-4">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.region)">
                                        <label>Geographical Area</label>
                                        <select v-model="vehicle.region" required name="region" class="form-control">
                                            <option disabled>Select G.A</option>
                                            <option v-for="(item, index) in region_list" :key="index" :value="item.key">
                                                {{ item.value }}
                                            </option>
                                        </select>
                                        <field-messages name="region" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Geographical Area is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-4">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.regNo)">
                                        <label>Registration No</label>
                                        <input type="text" maxlength="10" minlength="10" name="regNo" class="form-control"
                                            required v-model.lazy="vehicle.regNo" placeholder="Registration No"
                                            :readonly="true">
                                        <field-messages name="regNo" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Registration no is a required field</div>
                                            <div slot="pattern">Registration no is invalid</div>
                                            <div slot="minlength">Minimum length of registration no is 10 character</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-4">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.capacity)">
                                        <label>Capacity (WL)</label>
                                        <input type="number" min="100" max="30000" name="capacity" class="form-control"
                                            required v-model.lazy="vehicle.capacity" placeholder="Capacity">
                                        <field-messages name="capacity" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Capacity is a required field</div>
                                            <div slot="pattern">Capacity is invalid</div>
                                            <div slot="min">Minimum 100 kg Capacity</div>
                                            <div slot="max">Maximum 30000 kg Capacity</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-4">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.cylinders)">
                                        <label>Cascade Capacity</label>
                                        <input type="number" name="cylinders" class="form-control" required
                                            v-model.lazy="vehicle.cylinders" placeholder="Cylinders">
                                        <field-messages name="cylinders" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required"> No. Of Cylinders is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-4">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.dateCommissioning)">
                                        <label for="dateAdded">Date of Commissioning</label>
                                        <date-picker required id="dateCommissioning" v-model="vehicle.dateCommissioning"
                                            lang="en" name="dateCommissioning" input-class="form-control" width="100%"
                                            use-utc="true" format="DD-MM-YYYY"></date-picker>
                                        <field-messages name="dateCommissioning" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Date of Commissioning is a required field</div>
                                            <div slot="pattern">Date of Commissioning is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">


                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-4">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.ownerName)">
                                        <label>Transporter Name</label>
                                        <input type="text" name="ownerName" class="form-control" required
                                            v-model.lazy="vehicle.ownerName" placeholder="Transporter Name">
                                        <field-messages name="ownerName" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Transporter name is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-4">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.ownerContact)">
                                        <label>Transporter Contact No.</label>
                                        <input name="ownerContact" class="form-control" required
                                            v-model.lazy="vehicle.ownerContact" placeholder="Transporter contact number"
                                            pattern="[78965][0-9]{9}">
                                        <field-messages name="ownerContact" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Transporter contact no. is a required field</div>
                                            <div slot="pattern">Transporter contact no. is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-4">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.deviceId)">
                                        <label>Device</label>
                                        <select v-model="vehicle.deviceId" required name="deviceId" class="form-control">
                                            <option value="" disabled>Select Device</option>
                                            <option v-for="(item, index) in device_name" :key="index" :value="item.key">
                                                {{ item.value }}
                                            </option>
                                        </select>
                                        <field-messages name="deviceId" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Device is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.transportSupervisorName)">
                                        <label>Transport Supervisor Name</label>
                                        <input type="text" name="transportSupervisorName" class="form-control" required
                                            v-model.lazy="vehicle.transportSupervisorName"
                                            placeholder="Transport Supervisor Name">
                                        <field-messages name="transportSupervisorName" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Supervisor Name is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.transportSupervisorContact)">
                                        <label>Transport Supervisor Contact</label>
                                        <input name="transportSupervisorContact" class="form-control" required
                                            v-model.lazy="vehicle.transportSupervisorContact"
                                            placeholder="Transport Supervisor Contact" pattern="[78965][0-9]{9}">
                                        <field-messages name="transportSupervisorContact" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Supervisor Contact is a required field</div>
                                            <div slot="pattern"> Supervisor Contact no. is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate class="form-group" :class="fieldClassName(formstate.ownerDetails)">
                                        <label>Transporter Address</label>
                                        <textarea class="form-control" name="ownerDetails"
                                            v-model.lazy="vehicle.ownerDetails" placeholder="Other Info">
                                        </textarea>
                                    </validate>
                                </div>
                            </div>
                            <!-- RC validity, Insurance Validity, PUC validity, Fitness Certificate Validity, Goods Carriage permit validity -->
                            <div class="col-sm-12">
                                <div class="col-sm-3" id="licenseExpiryDiv">
                                    <validate auto-label class="form-group required-field">
                                        <label for="dateAdded">RC validity</label>
                                        <date-picker required id="rcValidity" v-model="vehicle.rcValidity" lang="en"
                                            name="rcValidity" width="100%" use-utc="true" format="DD-MM-YYYY"></date-picker>
                                        <field-messages name="rcValidity" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">RC validity is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group " :class="fieldClassName(formstate.rcDoc)">
                                        <label>RC Doc</label>
                                        <input type="file" id="fileinput1" accept="image/jpeg,image/jpg,application/pdf"
                                            @change="onFilechanged1" class="form-control" required />
                                        <field-messages name="photo" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>

                                <div class="col-sm-3" id="licenseExpiryDiv">
                                    <validate auto-label class="form-group required-field">
                                        <label for="dateAdded">Insurance Validity</label>
                                        <date-picker required id="insuranceValidity" v-model="vehicle.insuranceValidity"
                                            lang="en" name="insuranceValidity" width="100%" use-utc="true"
                                            format="DD-MM-YYYY"></date-picker>
                                        <field-messages name="insuranceValidity" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Insurance Validity is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.insuranceDoc)">
                                        <label>Insurance Doc</label>
                                        <input type="file" id="fileinput2" accept="image/jpeg,image/jpg,application/pdf"
                                            @change="onFilechanged2" class="form-control" required />
                                        <field-messages name="photo" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>

                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-3" id="licenseExpiryDiv">
                                    <validate auto-label class="form-group required-field">
                                        <label for="dateAdded">PUC validity</label>
                                        <date-picker required id="pucValidity" v-model="vehicle.pucValidity" lang="en"
                                            name="pucValidity" width="100%" use-utc="true"
                                            format="DD-MM-YYYY"></date-picker>
                                        <field-messages name="pucValidity" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">PUC validity is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.pucDoc)">
                                        <label>PUC Doc</label>
                                        <input type="file" id="fileinput3" accept="image/jpeg,image/jpg,application/pdf"
                                            @change="onFilechanged3" class="form-control" required />
                                        <field-messages name="photo" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>

                                <div class="col-sm-3" id="licenseExpiryDiv">
                                    <validate auto-label class="form-group required-field">
                                        <label for="dateAdded">Fitness Certificate Validity</label>
                                        <date-picker required id="fitCertValidity" v-model="vehicle.fitCertValidity"
                                            lang="en" name="fitCertValidity" width="100%" use-utc="true"
                                            format="DD-MM-YYYY"></date-picker>
                                        <field-messages name="fitCertValidity" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Fitness Certificate Validity is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.fitCertDoc)">
                                        <label>Fitnness Certificate Doc</label>
                                        <input type="file" id="fileinput4" accept="image/jpeg,image/jpg,application/pdf"
                                            @change="onFilechanged4" class="form-control" required />
                                        <field-messages name="photo" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>

                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6" id="licenseExpiryDiv">
                                    <validate auto-label class="form-group required-field">
                                        <label for="dateAdded">Goods Carriage permit validity</label>
                                        <date-picker required id="gcpValidity" v-model="vehicle.gcpValidity" lang="en"
                                            name="gcpValidity" width="100%" use-utc="true"
                                            format="DD-MM-YYYY"></date-picker>
                                        <field-messages name="gcpValidity" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Goods Carriage permit validity is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.gcpDoc)">
                                        <label>Goods Carriage permit Doc</label>
                                        <input type="file" id="fileinput5" accept="image/jpeg,image/jpg,application/pdf"
                                            @change="onFilechanged5" class="form-control" required />
                                        <field-messages name="photo" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>

                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group"
                                        :class="fieldClassName(formstate.hCVCommissioningCumAuditReport)">
                                        <label> HCV Commissioning cum Audit Report</label>
                                        <input type="file" id="fileinput6" accept="image/jpeg,image/jpg,application/pdf"
                                            @change="onFilechanged6" class="form-control" required />
                                        <field-messages name="photo" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>

                                <div class="col-sm-6">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.vehicleImage)">
                                        <label> Vehicle images</label>
                                        <input type="file" id="fileinput7" accept="image/jpeg,image/jpg"
                                            @change="onFilechanged7" class="form-control" required />
                                        <field-messages name="photo" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>

                            </div>
                            <!-- <div class="col-sm-12">
                            <div class="col-sm-12">
                                <div class="col-sm-3" id="licenseExpiryDiv" >
                                    <validate auto-label class="form-group required-field">
                                        <label for="dateAdded">RC validity</label>                                    
                                        <date-picker required id="rcValidity" v-model="vehicle.rcValidity" lang="en" name="rcValidity"  width="100%" use-utc="true"  format="DD-MM-YYYY" ></date-picker>
                                        <field-messages name="rcValidity" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">>RC validity is a required field</div>
                                        </field-messages>
                                    </validate>                                 
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.rcDoc)">
                                        <label>RC Doc</label>
                                        <input type="file" id="fileinput" @change="onFilechanged1" class="form-control" required />
                                        <field-messages name="photo" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                
                                <div class="col-sm-3" id="licenseExpiryDiv" >
                                    <validate auto-label class="form-group required-field">
                                        <label for="dateAdded">Insurance Validity</label>                                    
                                        <date-picker required id="insuranceValidity" v-model="vehicle.insuranceValidity" lang="en" name="insuranceValidity"  width="100%" use-utc="true"  format="DD-MM-YYYY" ></date-picker>
                                        <field-messages name="insuranceValidity" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Insurance Validity is a required field</div>
                                        </field-messages>
                                    </validate>                                 
                                </div>  
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.insuranceDoc)">
                                        <label>Insurance Doc</label>
                                        <input type="file" id="fileinput" @change="onFilechanged2" class="form-control" required />
                                        <field-messages name="photo" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>
                               
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-3" id="licenseExpiryDiv" >
                                    <validate auto-label class="form-group required-field">
                                        <label for="dateAdded">PUC validity</label>                                    
                                        <date-picker required id="pucValidity" v-model="vehicle.pucValidity" lang="en" name="pucValidity"  width="100%" use-utc="true"  format="DD-MM-YYYY" ></date-picker>
                                        <field-messages name="pucValidity" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">>PUC validity is a required field</div>
                                        </field-messages>
                                    </validate>                                 
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.pucDoc)">
                                        <label>PUC Doc</label>
                                        <input type="file" id="fileinput" @change="onFilechanged3" class="form-control" required />
                                        <field-messages name="photo" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                
                                <div class="col-sm-3" id="licenseExpiryDiv" >
                                    <validate auto-label class="form-group required-field">
                                        <label for="dateAdded">Fitness Certificate Validity</label>                                    
                                        <date-picker required id="fitCertValidity" v-model="vehicle.fitCertValidity" lang="en" name="fitCertValidity"  width="100%" use-utc="true"  format="DD-MM-YYYY" ></date-picker>
                                        <field-messages name="fitCertValidity" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Fitness Certificate Validity is a required field</div>
                                        </field-messages>
                                    </validate>                                 
                                </div>  
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.fitCertDoc)">
                                        <label>Fitnness Certificate Doc</label>
                                        <input type="file" id="fileinput" @change="onFilechanged4" class="form-control" required />
                                        <field-messages name="photo" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>
                               
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-3" id="licenseExpiryDiv" >
                                    <validate auto-label class="form-group required-field">
                                        <label for="dateAdded">Goods Carriage permit validity</label>                                    
                                        <date-picker required id="gcpValidity" v-model="vehicle.gcpValidity" lang="en" name="gcpValidity"  width="100%" use-utc="true"  format="DD-MM-YYYY" ></date-picker>
                                        <field-messages name="gcpValidity" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">>Goods Carriage permit validity is a required field</div>
                                        </field-messages>
                                    </validate>                                 
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group" :class="fieldClassName(formstate.gcpDoc)">
                                        <label>Goods Carriage permit Doc</label>
                                        <input type="file" id="fileinput" @change="onFilechanged5" class="form-control" required />
                                        <field-messages name="photo" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Please upload less than 3mb picture</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.deviceId)">
                                        <label>Device</label>
                                        <select v-model="vehicle.deviceId" required name="deviceId" class="form-control">
                                            <option disabled>Device</option>
                                            <option v-for="(item,index) in device_name" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="deviceId" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Device is a required field</div>
                                        </field-messages>
                                    </validate>
                                        </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate class="form-group" :class="fieldClassName(formstate.permitDetails)">
                                        <label>Permit Details</label>
                                        <input type="text" name="permitDetails" class="form-control" v-model.lazy="vehicle.permitDetails" placeholder="Permit Details">
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate class="form-group" :class="fieldClassName(formstate.billingInfo)">
                                        <label>Billing Info</label>
                                        <input type="text" name="billingInfo" class="form-control" v-model.lazy="vehicle.billingInfo" placeholder="Billing Info">
                                    </validate>
                                </div>                                
                            </div> -->
                            <div class="col-sm-12">
                                <!-- <div class="col-sm-6">
                                    <validate class="form-group" :class="fieldClassName(formstate.otherInfo)">
                                        <label>Other Info</label>
                                        <textarea class="form-control" name="otherInfo" v-model.lazy="vehicle.otherInfo" placeholder="Other Info">
                                        </textarea>
                                    </validate>
                                </div> -->
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.status)">
                                        <label>Status</label>
                                        <select required v-model="vehicle.status" name="status" class="form-control">
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                        <field-messages name="status" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Status is a required field</div>
                                            <div slot="pattern">Status date is invalid</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <label></label>
                                    <div class="mt">
                                        <validate class="form-group inline"
                                            :class="fieldClassName(formstate.cgpsMonitoring)">
                                            <label class="checkbox-inline"><input type="checkbox"
                                                    v-model.lazy="vehicle.camera" :checked="vehicle.camera" value="false"
                                                    name="camera">Camera</label>
                                        </validate>
                                        <validate class="form-group inline" :class="fieldClassName(formstate.camera)">
                                            <label class="checkbox-inline"><input type="checkbox"
                                                    v-model.lazy="vehicle.cgpsMonitoring" :checked="vehicle.cgpsMonitoring"
                                                    value="false" name="cgpsMonitoring">GPS Monitoring</label>
                                        </validate>
                                    </div>
                                </div>
                            </div>
                        </vue-form>
                        <div class="col-sm-12 text-right">
                            <router-link :to="{ name: 'Vehicle' }">
                                <button class="mr-5 btn btn-default" type="button">Cancel</button>
                            </router-link>
                            <button class="mr-2 btn gradientbt" type="submit" @click="updateVehicle"
                                :disabled="!(formstate.$dirty && formstate.$valid) && !(docsValid1 || docsValid2 || docsValid3 || docsValid4 || docsValid5 || docsValid6 || docsValid7)"
                                v-permission.if="[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER]">Update
                                Vehicle</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {
    formService,
    eventBus,
    vehicleService
} from '../../../services'
import {
    EVENTS
} from '../../../config'
import swal from 'sweetalert2'
import {
    USER_ROLES
} from '../../../config';
import {
    mapState
} from 'vuex';

export default {
    name: 'VehicleDetail',
    data() {
        return {
            regionManagersIdList: [],
            USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            formstate: {},
            region_list: {},
            device_name: {},
            vehicle: {
                status: 'active'
            },
            docsValid1: false,
            docsValid2: false,
            docsValid3: false,
            docsValid4: false,
            docsValid5: false,
            docsValid6: false,
            docsValid7: false,
            formValid: false,

        }
    },

    mounted: function () {
        this.getRegionList()
        this.getDeviceName()
    },
    methods: {
        fieldClassName: formService.fieldClassName,



        getVehicle() {
            return this.$vehicleDataRepository.find(this.$route.params._id)
                .then((response) => {
                    this.vehicle = response.data;
                })
                .catch((error) => {
                    this.$snotify.error('Region detail failed', 'Error!')
                })
        },
        validateRegistration: function (e) {
            let keyCode = e.keyCode || e.which;
            if (keyCode == 32)
                e.preventDefault();
            else
                this.vehicle = {
                    ...this.vehicle,
                    regNo: e.target.value.toUpperCase()
                }
        },

        updateFormValidity() {
            this.formValid = this.docsValid1 && this.docsValid2 && this.docsValid3 && this.docsValid4 && this.docsValid5 && this.docsValid6 && this.docsValid7;

        },

        onFilechanged1(event) {
            this.docsValid1 = false;
            const fileinput = document.getElementById("fileinput1");
            if (event.target.files[0] != undefined) {
                if (
                    ["image/jpeg", "image/jpg", "application/pdf"].includes(
                        event.target.files[0]["type"]
                    )
                ) {
                    this.docs1 = event.target.files[0]
                    this.vehicle.rcDoc = event.target.files[0]['name']
                    this.docsValid1 = true;
                } else {
                    this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                    fileinput.value = "";
                    this.docsValid1 = false;
                }
            }
            this.updateFormValidity();
        },
        onFilechanged2(event) {
            this.docsValid2 = false;
            if (
                ["image/jpeg", "image/jpg", "application/pdf"].includes(
                    event.target.files[0]["type"]
                )
            ) {
                this.docs2 = event.target.files[0]
                this.vehicle.insuranceDoc = event.target.files[0]['name']
                this.docsValid2 = true;
            } else {
                this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                fileinput.value = "";
                this.docsValid2 = false;
            }
            this.updateFormValidity();
        },
        onFilechanged3(event) {
            this.docsValid3 = false;
            const fileinput = document.getElementById("fileinput3");
            if (
                ["image/jpeg", "image/jpg", "application/pdf"].includes(
                    event.target.files[0]["type"]
                )
            ) {
                this.docs3 = event.target.files[0]
                this.vehicle.pucDoc = event.target.files[0]['name']
                this.docsValid3 = true;
            } else {
                this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                fileinput.value = "";
                this.docsValid3 = false;
            }
            this.updateFormValidity();
        },
        onFilechanged4(event) {
            this.docsValid4 = false;
            const fileinput = document.getElementById("fileinput4");
            if (
                ["image/jpeg", "image/jpg", "application/pdf"].includes(
                    event.target.files[0]["type"]
                )
            ) {
                this.docs4 = event.target.files[0]
                this.vehicle.fitCertDoc = event.target.files[0]['name']
                this.docsValid4 = true;
            } else {
                this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                fileinput.value = "";
                this.docsValid4 = false;
            }
            this.updateFormValidity();
        },
        onFilechanged5(event) {
            this.docsValid5 = false;
            const fileinput = document.getElementById("fileinput5");
            if (
                ["image/jpeg", "image/jpg", "application/pdf"].includes(
                    event.target.files[0]["type"]
                )
            ) {
                this.docs5 = event.target.files[0]
                this.vehicle.gcpDoc = event.target.files[0]['name']
                this.docsValid5 = true;
            } else {
                this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                fileinput.value = "";
                this.docsValid5 = false;
            }
            this.updateFormValidity();
        },
        onFilechanged6(event) {
            this.docsValid6 = false;
            const fileinput = document.getElementById("fileinput6");
            if (event.target.files[0] != undefined) {
                if (
                    ["image/jpeg", "image/jpg", "application/pdf"].includes(
                        event.target.files[0]["type"]
                    )
                ) {
                    this.docs6 = event.target.files[0]
                    this.vehicle.hCVCommissioningCumAuditReport = event.target.files[0]['name']
                    this.docsValid6 = true;
                } else {
                    this.$snotify.error("Upload jpeg,jpg,pdf files", "Error!");
                    fileinput.value = "";
                    this.docsValid6 = false;
                }
            }
            this.updateFormValidity();
        },
        onFilechanged7(event) {
            this.docsValid7 = false;
            const fileinput = document.getElementById("fileinput7");
            if (event.target.files[0] != undefined) {
                if (
                    ["image/jpeg", "image/jpg"].includes(
                        event.target.files[0]["type"]
                    )
                ) {
                    this.docs7 = event.target.files[0]
                    this.vehicle.vehicleImage = event.target.files[0]['name']
                    this.docsValid7 = true;
                } else {
                    this.$snotify.error("Upload jpeg,jpg files", "Error!");
                    fileinput.value = "";
                    this.docsValid7 = false;
                }
            }
            this.updateFormValidity();
        },
        uploadDocument(docId) {
            let formData = new FormData();
            if (this.docs1) {
                formData.append("file", this.docs1);
            }
            if (this.docs2) {
                formData.append("file", this.docs2);
            }
            if (this.docs3) {
                formData.append("file", this.docs3);
            }
            if (this.docs4) {
                formData.append("file", this.docs4);
            }
            if (this.docs5) {
                formData.append("file", this.docs5);
            }
            if (this.docs6) {
                formData.append("file", this.docs6);
            }
            if (this.docs7) {
                formData.append("file", this.docs7);
            }

            formData.append("model", "vehicle");
            formData.append("docId", docId);
            axios
                .post("fileUpload", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    console.log(res);
                    console.log("SUCCESS!!");
                })
                .catch(function () {
                    console.log("FAILURE!!");
                });
        },
        getRegionList() {
            this.loading = true;
            const params = {}
            params.$limit = 0;
            // if (this.user.roleName == "GA Head") {
            //     params.regionManager = this.user._id
            // }
            if (this.regionManagersIdList.length !== 0) {
                params.regionManager = this.regionManagersIdList;
            }
            let regionlist = [];
            this.$regionDataRepository.list(params)
                .then((res) => {
                    this.loading = false;
                    if (res.data.docs) {
                        regionlist = res.data.docs.map((item) => {
                            return {
                                key: item._id,
                                value: item.name
                            }
                        })

                    }
                    this.region_list = regionlist;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error('Region.requestFunction-error:', error)
                    this.$snotify.error('Get region list failed', 'Error!')
                })
        },
        getDeviceName() {
            this.loading = true;
            const params = {}
            params.$limit = 0;
            //params.roleRank = 4;
            let deviceList = [];
            this.$deviceDataRepository.list(params)
                .then((res) => {
                    this.loading = false;
                    if (res.data.docs) {
                        deviceList = res.data.docs.map((item) => {
                            return {
                                key: item._id,
                                value: item.deviceId,

                            }
                        })

                    }
                    this.device_name = deviceList;

                })
                .catch((error) => {
                    this.loading = false;
                    console.error('device.requestFunction-error:', error)
                    this.$snotify.error('Get device list failed', 'Error!')
                })
        },
        updateVehicle() {
            this.loading = true;
            return vehicleService.updateVehicle(this.vehicle)
                .then((response) => {
                    let docId = response._id;
                    if (this.docsValid1 || this.docsValid2 || this.docsValid3 || this.docsValid4 || this.docsValid5 || this.docsValid6 || this.docsValid7) {
                        this.uploadDocument(docId);
                    }
                    this.loading = false
                    this.flash = false
                    this.$snotify.success('Vehicle updated!', 'Success!')
                    this.$router.push('/vehicle')
                })
                .catch(error => {
                    this.loading = false
                    this.$snotify.error('vehicle Add failed! Try Again', 'Error!')
                    if (error.data.message.includes('must be one of')) {
                        this.flash = true
                        this.flashType = 'error'
                        this.flashMessage = 'New vehicle add is failed.Please try again!'
                    }
                })
        },
        deleteVehicleModal() {
            swal({
                title: 'Are you sure?',
                text: 'This will permanently delete this Vehicle!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                customClass: 'swal-modal2',
                width: '400px',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.value) {
                    this.deleteVehicle()
                }
            })
        },
        deleteVehicle() {
            this.loading = true
            return this.$vehicleDataRepository.deleteOne(this.vehicle._id)
                .then((response) => {
                    this.loading = false;
                    return swal(
                        'Deleted!',
                        'Vehicle has been deleted.',
                        'success'
                    )
                })
                .then((response) => {
                    this.loading = false;
                    this.$router.push('/vehicle')
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error('Delete vehicle failed', 'Error!')
                })
        },
        fieldClassName: function (field) {
            if (!field) {
                return '';
            }
            if ((field.$touched || field.$submitted) && field.$valid) {
                return 'has-success';
            }
            if ((field.$touched || field.$submitted) && field.$invalid) {
                return 'has-danger';
            }
        }
    },
    created() {
        const promises = []
        this.loading = true
        promises.push(this.getVehicle())
        Promise.all(promises)
            .then(() => {
                this.loading = false
                this.ready = true
            })
            .catch(() => {
                this.loading = false
            })
        let regionDetails = this.$store.state.auth.userRegion.regionDetails
        if (regionDetails && regionDetails.length !== 0) {
            this.regionManagersIdList = regionDetails.map(item => item.regionManager);
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
        })
    }
}
</script>

<style scoped>
.required-field>label::after {
    content: '*';
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red
}

.mt {
    margin-top: 7px;
}

.swal-text {
    font-size: 100px !important;
}

.gradientbt {
    background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
    color: white
}
</style>



// WEBPACK FOOTER //
// VehicleDetail.vue?1d4b94ce